module.exports = __webpack_public_path__ + "static/event5-c3410d2cafdd5896c8f9a8fb844f2c31.jpeg";